module.exports = __webpack_public_path__ + "static/media/galerija_2017 (12).18d16422.jpg";